
import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion';
import {
    CCol, CButton, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter,
    CNav, CNavItem, CNavLink, CTabContent, CTabPane, CFormTextarea
} from '@coreui/react';
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import PECopyDescription from './PECopyDescription';
const PEDescription = ({ descriptionId, setDescriptionId, descriptionText, setDescriptionText, generalExaminationData, setGeneralExaminationData, apiType }) => {
    const [activeTab, setActiveTab] = useState(0)

    const handleSaveDescription = () => {

        try {
            const AddEditDescription = (data, id, descriptionText) => {
                if (!data || !Array.isArray(data)) {
                    return data;
                }

                return data.map((item) => {

                    if (!item.hasOwnProperty('alert')) {
                        item.alert = '';
                    }

                    if (item.id === id) {

                        return { ...item, alert: descriptionText };
                    } else if (item.isHierarchy && Array.isArray(item.hierarchy)) {
                        return { ...item, hierarchy: AddEditDescription(item.hierarchy, id, descriptionText) };
                    }
                    return item;
                });
            };

            const updatedData = AddEditDescription(generalExaminationData, descriptionId, descriptionText);

            setGeneralExaminationData(updatedData);
            toast.success('Description Saved', toastConfig);
        } catch (error) {
            console.error("Error updating description:", error);
        }
    };
    return (
        <>
            <div className='w-100 ' >
                <div className='pe-tab-underline-nav mb-4'>
                    <CNav role="tablist" className="justify-content-center">
                        <CNavItem>
                            <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                                Add
                            </CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink active={activeTab === 1} onClick={() => {
                                setActiveTab(1)
                            }}>
                                Copy
                            </CNavLink>
                        </CNavItem>
                    </CNav>
                </div>
                <div className='mt-2' activeTab={activeTab} onActiveTabChange={setActiveTab}>
                    <CTabContent>
                        {activeTab === 0 && <CTabPane visible={activeTab === 0}>
                            <div>
                                <div className="mx-5">
                                    <CFormTextarea
                                        style={{ height: '400px', color: '#ffc107', caretColor: 'black' }}
                                        className="form-control"
                                        value={descriptionText}
                                        onChange={(e) => {
                                            setDescriptionText(e.target.value)
                                        }}
                                        placeholder="Enter Description"

                                    ></CFormTextarea>
                                </div >
                                <div className="mx-5 my-2 m-0 d-flex justify-content-end gap-3">
                                    {/* <CButton variant="outline" color="secondary" onClick={() => setDescriptionId("")}>
                                                                    Close
                                                                </CButton> */}
                                    <CButton
                                        onClick={handleSaveDescription}
                                        className="ui-action-btn ui-action-btn--primary">Save Description</CButton>
                                </div>

                            </div>

                        </CTabPane >}
                        {activeTab === 1 && <CTabPane visible={activeTab === 1} className=' w-100 d-flex flex-column  justify-content-center align-items-center'>
                            <div className='w-100' style={{ height: '200px' }} >
                                <PECopyDescription setGeneralExaminationData={setGeneralExaminationData} generalExaminationData={generalExaminationData} parentID={descriptionId} setActiveTab={setActiveTab} setDescriptionText={setDescriptionText} apiType={apiType} />
                            </div>
                        </CTabPane>}
                    </CTabContent>
                </div>

            </div>
        </>
    )
}

export default PEDescription
